<script setup>
import {useBaseStore} from "~/stores/base";
import {useProductStore} from "~/stores/product";
import Drawer from "~/components/Drawer.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import SlideCurrentProductVoteResult
  from "~/components/product/DrawerProductVoteCreator/SlideCurrentProductVoteResult.vue";
import SlideAllProductsVoteResult from "~/components/product/DrawerProductVoteCreator/SlideAllProductsVoteResult.vue";
import _ from "lodash";
import SlideProductPollsNotificationSettings
  from "~/components/product/DrawerProductVoteCreator/SlideProductPollsNotificationSettings.vue";
import {Setting} from "@element-plus/icons-vue";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits([])

/** props **/
const props = defineProps({})

/** data **/
const swiperInstance = ref(null);
const swiperSlideIndex = ref(0)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const open = computed(() => useProductStore().getterIsShowDrawerProductVoteCreator)
const voteRole = computed(() => useProductStore().getterVoteRole)
const voteData = computed(() => useProductStore().getterVoteData)

/** watch **/

/** methods **/
const handleClose = () => {
  const query = _.cloneDeep(router.currentRoute.value.query)
  delete query.voteId
  // 获取当前路径，但去掉 hash 部分
  router.replace({
    path: router.currentRoute.value.path,
    query: query, // 更新query
    hash: router.currentRoute.value.hash
  });
}
const onSwiper = (swiper) => {
  swiperInstance.value = swiper; // 保存 Swiper 实例
};
const onSlideChange = (e) => {
  swiperSlideIndex.value = e.activeIndex
};
const handleSeeAll = () => {
  swiperInstance.value.slideTo(1)
}
const handleSettings = () => {
  swiperInstance.value.slideTo(2)
}
const handleBack = () => {
  const index = swiperSlideIndex.value - 1
  swiperInstance.value.slideTo(index)
}

/** lifecycle **/

</script>

<template>
  <div class="drawer-product-vote-creator-mobile" v-if="isMobile">
    <Drawer
      :open="open"
      @close="handleClose"
      :btn-close-visible="false"
      :position="'bottom'"
      :border-radius="'8px 8px 0 0'"
      :z-index="4"
      :global-header-visible="false"
    >
      <div class="drawer" v-if="open">
        <div class="drawer-header">
          <div class="drawer-header-left">
            <div class="back" v-if="swiperSlideIndex !== 0" @click="handleBack"><img src="@/assets/img/icon-arrow-left.svg" alt="icon"></div>
          </div>
          <div class="title">
            <div class="title-content" v-if="swiperSlideIndex === 0">{{voteData.topTitle}}</div>
            <div class="title-content" v-if="swiperSlideIndex === 1">
              all voted items
              <div class="icon" @click="handleSettings">
                <el-icon color="#292929" size="20">
                  <Setting/>
                </el-icon>
              </div>
            </div>
            <div class="title-content" v-if="swiperSlideIndex === 2">notification settings</div>
          </div>
          <div class="close" @click="handleClose">
            <img src="@/assets/img/icon-close-black.svg" alt="icon">
          </div>
        </div>
        <div class="drawer-body">
          <swiper
            :allow-touch-move="false"
            :initial-slide="swiperSlideIndex"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide>
              <slide-current-product-vote-result @see-all="handleSeeAll" @close="handleClose"/>
            </swiper-slide>
            <swiper-slide>
              <slide-all-products-vote-result :swiper-slide-index="swiperSlideIndex"/>
            </swiper-slide>
            <swiper-slide>
              <slide-product-polls-notification-settings :swiper-slide-index="swiperSlideIndex"/>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="drawer-product-vote-creator-desktop" v-else>
    <Drawer :open="open" :position="'right'" @close="handleClose">
      <div class="drawer" v-if="open">
        <div class="drawer-header">
          <div class="drawer-header-left">
            <div class="back" v-if="swiperSlideIndex !== 0" @click="handleBack"><img src="@/assets/img/icon-arrow-left.svg" alt="icon"></div>
          </div>
          <div class="title">
            <div class="title-content" v-if="swiperSlideIndex === 0">{{voteData.topTitle}}</div>
            <div class="title-content" v-if="swiperSlideIndex === 1">
              all voted items
              <div class="icon" @click="handleSettings">
                <el-icon color="#292929" size="20">
                  <Setting/>
                </el-icon>
              </div>
            </div>
            <div class="title-content" v-if="swiperSlideIndex === 2">notification settings</div>
          </div>
          <div class="close" @click="handleClose"><img src="@/assets/img/icon-close-black.svg" alt="icon"></div>
        </div>
        <div class="drawer-body">
          <swiper
            :allow-touch-move="false"
            :initial-slide="swiperSlideIndex"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide>
              <slide-current-product-vote-result @see-all="handleSeeAll" @close="handleClose"/>
            </swiper-slide>
            <swiper-slide>
              <slide-all-products-vote-result :swiper-slide-index="swiperSlideIndex"/>
            </swiper-slide>
            <swiper-slide>
              <slide-product-polls-notification-settings :swiper-slide-index="swiperSlideIndex"/>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.drawer-product-vote-creator-mobile {
  .drawer {
    width: 100%;
    height: calc(100vh - $mobile-header-height - $mobile-safari-address-bar-height - 18px);
    padding-top: 14px;
    display: flex;
    flex-direction: column;

    .drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 16px;
      position: relative;

      .drawer-header-left {
        width: 40px;
        height: 40px;

        .back {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .title {
        /* Eyebrow/medium */
        font-family: "TWK Lausanne";
        font-size: 14px;
        font-style: normal;
        font-weight: 650;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.056px;
        text-transform: uppercase;

        .title-content {
          display: flex;
          align-items: center;

          .icon {
            cursor: pointer;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;

            position: absolute;
            right: 72px;
          }
        }
      }

      .close {
        cursor: pointer;
        flex-shrink: 0;

        border: 1px solid $color-BNTO-beige-dark;

        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
      }
    }

    .drawer-body {
      flex: 1;
      overflow-y: hidden;
      padding: 0 16px;
      margin-top: 16px;

      .swiper {
        height: 100%;

        .swiper-slide {
          height: 100%;
        }
      }
    }
  }
}

.drawer-product-vote-creator-desktop {
  .drawer {
    width: 432px;
    height: calc(100vh - $desktop-header-height);
    padding-top: 14px;
    display: flex;
    flex-direction: column;

    .drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 16px;
      position: relative;

      .drawer-header-left {
        width: 40px;
        height: 40px;

        .back {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .title {
        font-family: "Alternate Gothic No3 D";
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px; /* 88.889% */
        letter-spacing: -0.36px;
        text-transform: uppercase;
        padding-top: 12px;

        .title-content {
          display: flex;
          align-items: center;

          .icon {
            cursor: pointer;
            margin-top: -12px;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;

            position: absolute;
            right: 72px;
          }
        }
      }

      .close {
        cursor: pointer;
        flex-shrink: 0;

        border: 1px solid $color-BNTO-beige-dark;

        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
      }
    }

    .drawer-body {
      flex: 1;
      overflow-y: hidden;
      padding: 0 16px;
      margin-top: 16px;

      .swiper {
        height: 100%;

        .swiper-slide {
          height: 100%;
        }
      }
    }
  }
}
</style>
